import { render, staticRenderFns } from "./QCReportDetail.vue?vue&type=template&id=036f6eec"
import script from "./QCReportDetail.vue?vue&type=script&lang=js"
export * from "./QCReportDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports